import { render, staticRenderFns } from "./RelAdminRadar.vue?vue&type=template&id=2da67756&scoped=true"
import script from "./RelAdminRadar.vue?vue&type=script&lang=js"
export * from "./RelAdminRadar.vue?vue&type=script&lang=js"
import style0 from "./RelAdminRadar.vue?vue&type=style&index=0&id=2da67756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da67756",
  null
  
)

export default component.exports